import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Cluster Responsible Person Assignment: The association(s) between personnel and cluster as responsible persons.',
    name: 'Cluster Responsible Person Assignments',
    partialId: PartialId.Standard.create('cluster_resp_person'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
